import { coreUsersCurrentGetAsyncSlice } from './get';
import { coreUsersCurrentPatchSlice } from './patch';
import { updateCurrentUserSyncSlice } from './update';

export const { receiveGetCoreUsersCurrent, requestGetCoreUsersCurrent, resetGetCoreUsersCurrent } =
	coreUsersCurrentGetAsyncSlice.asyncActionCreators;

export const { requestPatchCoreUsersCurrent, resetPatchCoreUsersCurrent } =
	coreUsersCurrentPatchSlice.asyncActionCreators;

export const { syncActionCreator: updateCoreUsersCurrent } = updateCurrentUserSyncSlice;

export * from './picture/actions';
